'use client';

import Link from 'next/link';
import { Trans, useTranslation } from 'react-i18next';

import { generateLink } from '@/helpers/common';
import { type IssuableItem, isWagerFreeCash } from '../lib/isUnseenBonus';
import { ScBonusReceivedTooltip } from './styled';
import { WagerFreeCashTooltip } from './WagerFreeCashTooltip';

const ACTIVE_BONUSES_TAB = 'active-bonuses';

interface BonusReceivedTooltipProps {
  incoming?: IssuableItem;
}

export const BonusReceivedTooltip = ({
  incoming,
}: BonusReceivedTooltipProps) => {
  const { t, i18n } = useTranslation('common');

  const href = `${generateLink('/promotions', i18n.language)}?tab=${ACTIVE_BONUSES_TAB}`;

  if (incoming && isWagerFreeCash(incoming)) {
    return (
      <WagerFreeCashTooltip
        amountCents={incoming.amountCents as number}
        currency={incoming.currency as string}
      />
    );
  }

  return (
    <ScBonusReceivedTooltip>
      <strong className="title">{t('bonusReceived.title')}</strong>
      <p className="text">
        <Trans
          components={{ l: <Link className="link" href={href} /> }}
          i18nKey="bonusReceived.text"
          ns="common"
        />
      </p>
    </ScBonusReceivedTooltip>
  );
};
